module.exports = __webpack_public_path__ + "static/media/photo319.ce9d2d96.jpg";